import React, { useState, useEffect } from "react";
import { Mensaje } from "../../mensajes2";
import { Dimmer } from "../../spinner";
import useTable from "../../useTableR";
import axios from "axios";
import { ModalInsertarTasa } from "./modalInsertarTasa";
//UI
import { SearchInput } from "../../../ui/inputs/Input";
import { PrimaryButton } from "../../../ui/buttons/Button";
const headCells = [
  {
    id: "idcomercio",
    label: "CODIGO",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "descripcion",
    label: "DESCRIPCION",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "accion",
    label: "OPCIONES",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
];
function TablaTipoTasa(props) {
  let op = require("../../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const [activate, setActivate] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [permiso] = useState();
  const [records, setRecords] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [mostarModal, setMostrarModal] = useState(false);
  const [tipoTasa, setTipotasa] = useState();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const cerrarContri = () => {
    setMostrarModal(false);
  };
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.codigo.includes(target.value) ||
              x.descripcion.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };
  const blanquear = () => {
    setTipotasa();
  };
  const seleccionarValorPetro = () => {
    let endpoint = op.conexion + "/api/efiscal/valorpetro";
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status == 200) {
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarRegistros = () => {
    let campos = "*";
    let nomtab = "tipotasa";
    let orden = "idtipotasa";
    let endpoint =
      op.conexion +
      `/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setRecords(response.data);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarRegistro = (idtipotasa) => {
    let campos = "*";
    let nomtab = "tipotasa";
    let nomid = "idtipotasa";
    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idtipotasa}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status == 200) {
          setTipotasa(response.data);
          setActivate(false);
          setMostrarModal(true);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const consultarValor = (ope, id) => (event) => {
    event.preventDefault();
    if (ope === 1) {
      setMostrarModal(true);
      setOperacion(1);
      blanquear();
    } else if (ope === 4) {
      setOperacion(4);
      seleccionarRegistro(id);
    } else if (ope === 2) {
      setOperacion(2);
      seleccionarRegistro(id);
    } else if (ope === 3) {
      setOperacion(3);
      seleccionarRegistro(id);
    }
  };

  useEffect(() => {
    seleccionarRegistros();
    seleccionarValorPetro();
  }, []);

  const exitHandler = () => {
    props.setTabla(0);
  };

  return (
    <div className="col-8 m-0 p-2 border rounded">
        <header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant rounded-top text-light">
            <h3 className="fw-bold m-0">Gestion de Clasificador de Tasas</h3>
            <a onClick={exitHandler} className="text-light fw-bold fs-6">
            Salir <i className="fa fa-times ms-2"></i>
            </a>
        </header>
        <div className="col-12 m-0 my-2 p-0 d-flex justify-content-between">
            <div className="col-4 m-0 p-0">
            <SearchInput
                placeholder="Buscar"
                onChange={handleSearch}
            />
            </div>
            <div className="col-auto m-0 p-0">
            <PrimaryButton icon = 'fa-plus m-0'
                onClick={consultarValor(1, "")}
                disabled={permiso && permiso.substring(1, 2) !== "1"}
            />
            </div>
        </div>
        <div className="col-12 m-0 p-0">
        <TblContainer>
            <TblHead />
            <tbody>
            {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                <tr key={item.idtipotasa} style={{ padding: "0" }}>
                    <td
                    style={{
                        fontSize: "10px",
                        textAlign: "center",
                        width: "10px",
                    }}
                    >
                    {item.codigo}
                    </td>
                    <td
                    style={{
                        fontSize: "10px",
                        textAlign: "left",
                        width: "auto",
                    }}
                    >
                    {item.descripcion}
                    </td>

                    <td
                    className="py-1"
                    style={{
                        fontSize: "10px",
                        textAlign: "center",
                        width: "auto",
                    }}
                    >
                    <button
                        onClick={consultarValor(4, item.idtipotasa)}
                        className="rounded-pill btn btn-sm btn-info"
                    >
                        <i className="fas fa-eye"></i>{" "}
                    </button>
                    <a> &nbsp; </a>
                    <button
                        onClick={consultarValor(2, item.idtipotasa)}
                        className="rounded-pill btn btn-sm btn-warning"
                    >
                        <i className="fa fa-edit"></i>{" "}
                    </button>
                    <a> &nbsp; </a>
                    <button
                        onClick={consultarValor(3, item.idtipotasa)}
                        className="rounded-pill btn btn-sm btn-danger"
                    >
                        <i className="fa fa-trash-alt"></i>{" "}
                    </button>
                    </td>
                </tr>
                ))}
            </tbody>
        </TblContainer>
        <TblPagination />
        </div>
      <ModalInsertarTasa
        show={mostarModal}
        onHideCancela={cerrarContri}
        operacion={operacion}
        tipoTasa={tipoTasa}
        onHideRender={seleccionarRegistros}
      />

      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />

      <Dimmer active={activate} inverted></Dimmer>
    </div>
  );
}

export default TablaTipoTasa;
